import React from 'react';
import { CheckCircle, Cancel, Store, Inventory, AttachMoney } from '@mui/icons-material';

interface CustomProductTooltipProps {
  name: string;
  price: number;
  stock: number;
  branchName: string;
  isAvailable: boolean;
  isOpen?: boolean; // for controlled use
  onClose?: () => void;
}

const CustomProductTooltip: React.FC<CustomProductTooltipProps> = ({
  name,
  price,
  stock,
  branchName,
  isAvailable,
  isOpen = true,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="w-64 bg-white text-sm rounded-md shadow-lg p-4 border border-gray-200">
      <div className="font-semibold text-gray-800 mb-2">{name}</div>
      <div className="flex items-center gap-2 text-gray-700">
        <AttachMoney fontSize="small" className="text-green-500" />
        <span>Price:</span> <strong>${price}</strong>
      </div>
      <div className="flex items-center gap-2 text-gray-700 mt-1">
        <Inventory fontSize="small" className="text-yellow-600" />
        <span>Stock:</span> <strong>{stock}</strong>
      </div>
      <div className="flex items-center gap-2 text-gray-700 mt-1">
        <Store fontSize="small" className="text-blue-600" />
        <span>Branch:</span> <strong>{branchName}</strong>
      </div>
      <div className="flex items-center gap-2 mt-2">
        {isAvailable ? (
          <>
            <CheckCircle className="text-green-600" fontSize="small" />
            <span className="text-green-700 font-medium">Available</span>
          </>
        ) : (
          <>
            <Cancel className="text-red-600" fontSize="small" />
            <span className="text-red-700 font-medium">Not Available</span>
          </>
        )}
      </div>

      {onClose && (
        <button
          className="mt-3 w-full text-xs text-center text-primary underline"
          onClick={onClose}
        >
          Close
        </button>
      )}
    </div>
  );
};

export default CustomProductTooltip;
